import {
  Contribution,
  ContributionClassesAndRolesDDL,
  ContributionClassName,
  ContributionPatchValidationSchema,
  ContributionValidationSchema,
} from 'types/contribution';
import { Dispatch, SetStateAction } from 'react';
import { SearchableProfile } from 'types/notification.types';
import { Country, DDL, Option } from 'types/general.types';
import { GenericObject } from 'types/generic.types';
import { SearchProfilesValidationProperties } from 'types/profile';

export interface ContributionFormData {
  name: string;
  profileGuid?: string;
  contributor?: SearchableProfile | null;
  className?: ContributionClassName;
  artistIpn: string;
  composerIpi: string;
  producerIpn: string;
  performerIpn: string;
  artistIsni: string;
  composerIsni: string;
  producerIsni: string;
  performerIsni: string;
  artistRole: Option | null;
  composerRole: Option | null;
  productionRole: Option | null;
  performerRole: Option | null;
  performerRoleDetail: Option | null;
  otherRole: string;
  detail: string;
  date: {
    date?: Date | null;
  };
  location: {
    country?: Option | null;
    name?: string;
    address?: string;
  };
}

export enum PerformerRoleType {
  VOCALIST = 'Vocalist',
  MUSICIAN = 'Musician',
  ENSEMBLE = 'Ensemble',
  GROUP = 'Group', // TODO:: Deprecated. SS-2941
  VOCAL = 'Vocal', // TODO:: Deprecated. SS-2941
}

export enum IsCreditedType {
  YES = 'Yes',
  NO = 'No',
}

export interface ContributionClassNameOption {
  value: ContributionClassName;
  label: string;
  description: string;
}

export type PerformerRoleDetailHistory = GenericObject<string | undefined>;

export type SetPerformerRoleDetailHistory = Dispatch<
  SetStateAction<PerformerRoleDetailHistory>
>;

export interface ContributionFormComponentProps {
  contribution?: Contribution;
  countries: DDL;
  userCountry?: Country;
  contributionClassesAndRoles: ContributionClassesAndRolesDDL;
  handleContributionDelete: (guid: string) => Promise<void>;
  createOrUpdateContribution: (
    data: ContributionFormData,
    dirtyValues: Partial<ContributionFormData>
  ) => Promise<void>;
  affectsSplit?: boolean;
  setNewContributionClass: Dispatch<
    SetStateAction<ContributionClassName | undefined>
  >;
  searchProfilesValidation: SearchProfilesValidationProperties;
  patchValidation?: ContributionPatchValidationSchema;
  createValidation: ContributionValidationSchema;
  onClose: () => void;
}

export type GetDefaultValuesProp = (props: {
  contribution?: Contribution;
  countries: DDL;
  contributionClassesAndRoles: ContributionClassesAndRolesDDL;
}) => ContributionFormData;

export interface UseContributionFormProps {
  contribution?: Contribution;
  patchValidation?: ContributionPatchValidationSchema;
  createValidation: ContributionValidationSchema;
  countries: DDL;
  contributionClassesAndRoles: ContributionClassesAndRolesDDL;
  createOrUpdateContribution: ContributionFormComponentProps['createOrUpdateContribution'];
  onSuccessfulSubmit: () => void;
}

export interface UseCreateContributionProps {
  contribution?: Contribution;
  newContributionClass?: ContributionClassName;
}
